<template>
  <div class="layout">
    <br><br>
    <div class="passReset">
      <h3>重設密碼</h3>
      <mu-text-field v-model.trim="newPass" full-width label="請輸入新密碼" :action-icon="visibility ? 'visibility_off' : 'visibility'" :action-click="() => (visibility = !visibility)" :type="visibility ? 'text' : 'password'"></mu-text-field><br/>
      <mu-text-field :error-text="errorText" v-model.trim="checkPass" full-width label="請再次確認密碼" :action-icon="visibility ? 'visibility_off' : 'visibility'" :action-click="() => (visibility = !visibility)" :type="visibility ? 'text' : 'password'"></mu-text-field><br/>
      <br>
      <el-button :loading="isLoading" type="primary" style="width: 100%;" :disabled="!newPass || !checkPass" @click="sendChange">送出</el-button>
      <br><br>
    </div>
    <!-- dialog -->
    <div style="position: fixed; bottom: 10px; left: 20px; text-align: left;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      uid: this.$route.query.uid,
      newPass: '',
      isLoading: false,
      visibility: false,
      checkPass: '',
      errorText: ''
    };
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      changePass: 'changePass',
      getAESData: 'getAESData'
    }),
    sendChange() {
      if (this.checkPass !== this.newPass) {
        this.errorText = '輸入的密碼不符合';
      }
      else {
        this.errorText = '';
        if (!this.uid) {
          alert('修改密碼失敗');
        }
        else {
          this.isLoading = true;
          this.changePass({ uid: this.uid, newPass: this.newPass })
            .then(() => {
              this.isLoading = false;
              this.$notify({
                title: '修改密碼成功',
                type: 'success'
              });
              this.$router.push('/login');
            })
        }
      }
    }
  }
}

</script>

<style scoped>
  .passReset {
    width: 400px;
    border: 1px solid #eee;
    text-align: left;
    padding: 10px 20px;
    margin: 0 auto;
  }
</style>